import { render, staticRenderFns } from "./CurrentLevel.vue?vue&type=template&id=695c46ff&scoped=true&"
import script from "./CurrentLevel.vue?vue&type=script&lang=js&"
export * from "./CurrentLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695c46ff",
  null
  
)

export default component.exports